export class GLTFMaterilFactory {
}
export default new GLTFMaterilFactory();



// WEBPACK FOOTER //
// ./src/Parser/GLTFMaterialFactory.ts